import React from 'react';

const ICON_ID = 'icon-info';

const IconInfo = function(props) {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" aria-labelledby={ICON_ID}>
      <title id={ICON_ID}>Info Icon</title>
      <defs>
        <path id={`${ICON_ID}-a`} d="M0 25V.006h25V25z"/>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 -.006)">
          <mask id={`${ICON_ID}-b`} fill="#fff">
            <use xlinkHref={`#${ICON_ID}-a`}/>
          </mask><path d="M12.5.006C5.597.006 0 5.6 0 12.503S5.597 25 12.5 25 25 19.405 25 12.503C25 5.6 19.403.006 12.5.006m0 1.024c6.327 0 11.476 5.147 11.476 11.473 0 6.326-5.149 11.472-11.476 11.472-6.327 0-11.476-5.146-11.476-11.472S6.173 1.03 12.5 1.03" fill="#9D9D9D" mask={`url(#${ICON_ID})-b`}/>
        </g>
        <path d="M12.5 19.718V8.828M12.5 7.675V5.49" stroke="#9D9D9D" strokeWidth="1.537"/>
      </g>
    </svg>
  );
}

export default IconInfo;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-info.jsx